import script from "./TariffsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffsPage.vue?vue&type=script&setup=true&lang=js"

import "./TariffsPage.vue?vue&type=style&index=0&id=18f1894c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f1894c"]])

export default __exports__